import { render } from "./SelectPlaces.vue?vue&type=template&id=0ea3d710"
import script from "./SelectPlaces.vue?vue&type=script&lang=js"
export * from "./SelectPlaces.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/punchline-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__